export const iconFontAwesomeUsersPeopleUserSlash = (
	<i className="fa-solid fa-user-slash"></i>
);
